import { DollarApollo } from "vue-apollo/types/vue-apollo";
import { FetchResult } from "apollo-link";
import Mutation from "./mutation.gql";

export interface Result {
  deleteRoom: boolean;
}

export const deleteRoom = async <V>(
  apollo: DollarApollo<V>,
  roomId: string
): Promise<FetchResult<Result>> => {
  const result = apollo.mutate({
    mutation: Mutation,
    variables: { roomId }
  });
  await apollo.provider.defaultClient.cache.reset();
  return result;
};
